import './App.css';
import { useState, useEffect } from 'react';
import Header from './components/Header';
import Notes from './data/notes';
import Card from './components/Card';

function App() {
  const [cards] = useState(Notes);
  const [currentCard, setCurrentCard] = useState({});

  useEffect(() => {
    getRandomCard(cards);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cards]);

  const getRandomCard = (cards) => {
    const randomIndex = Math.floor(Math.random() * cards.length);
    const card = cards[randomIndex];
    if (card.id === currentCard.id) {
      getRandomCard(cards);
    } else {
      setCurrentCard(card);
    }

    return card;
  };

  return (
    <main className='App'>
      <Header />
      <Card
        cards={cards}
        getRandomCard={getRandomCard}
        currentCard={currentCard}
      />
    </main>
  );
}

export default App;
